import { Hand, HardHat } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const incidentsNav: NavEntry = {
  label: 'Safety',
  icon: HardHat,
  path: '/safety',
  permission: 'incidents:read',
  order: 22,
}

/** Help requests got their own home beside Assignment (AUDIT_FIXES_JULY27
 * Item N) — non-emergency floor assistance, not a safety artifact. Same
 * `incidents` module key and help:* permissions. */
export const helpRequestsNav: NavEntry = {
  label: 'Help requests',
  icon: Hand,
  path: '/help-requests',
  permission: 'help:raise',
  order: 21,
}
